import { useResetAtom } from 'jotai/utils'
import { useUnmount } from 'react-use'

import {
  commentAtom,
  dataDisplayTypeAtom,
  hiddenBrandIdsAtom,
  hiddenLabelBrandIdsAtom,
  hiddenSurveyIdsAtom,
  isChartMaxUnifiedAtom,
  isPendingTabulationAtom,
  isTabulationReadyAtom,
  savedCommentAtom,
  tableChartTypeAtom,
  tabulationQueryDataAtom,
} from '../atoms'

export const useResetOnUnmount = () => {
  const resetComment = useResetAtom(commentAtom)
  const resetSavedComment = useResetAtom(savedCommentAtom)

  const resetTableChartType = useResetAtom(tableChartTypeAtom)
  const resetDataDisplayType = useResetAtom(dataDisplayTypeAtom)
  const resetIsChartMaxUnified = useResetAtom(isChartMaxUnifiedAtom)
  const resetHiddenBrandIds = useResetAtom(hiddenBrandIdsAtom)
  const resetHiddenLabelBrandIds = useResetAtom(hiddenLabelBrandIdsAtom)
  const resetHiddenSurveyIds = useResetAtom(hiddenSurveyIdsAtom)

  const resetIsTabulationReady = useResetAtom(isTabulationReadyAtom)
  const resetIsPendingTabulation = useResetAtom(isPendingTabulationAtom)
  const resetTabulationQueryData = useResetAtom(tabulationQueryDataAtom)

  useUnmount(() => {
    resetComment()
    resetSavedComment()

    resetTableChartType()
    resetDataDisplayType()
    resetIsChartMaxUnified()
    resetHiddenBrandIds()
    resetHiddenLabelBrandIds()
    resetHiddenSurveyIds()

    resetIsTabulationReady()
    resetIsPendingTabulation()
    resetTabulationQueryData()
  })
}
